module.exports = __webpack_public_path__ + "img/dashboard-background.c2d25430.png";